"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const AppStateConstants_1 = require("../../types/AppStateConstants");
const getDbPathFromArrayOfValues_1 = __importDefault(require("../getDbPathFromArrayOfValues"));
const deleteDataDBBuilder = ({ isDevelopment }) => ({ entryVars: { updates: arrayPath, shouldUpdateDbCache = false }, callbacks, executeProcesses, processor, functionId, store, }) => {
    const { databaseCore } = processor.root;
    let pathToDelete;
    const onError = (errorData) => {
        executeProcesses(functionId, callbacks.errorProcess, errorData);
    };
    try {
        pathToDelete = (0, getDbPathFromArrayOfValues_1.default)(arrayPath);
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        onError(errorMessage);
        return;
    }
    const listener = (result) => {
        if (result) {
            executeProcesses(undefined, callbacks.sucessProcess);
            return;
        }
        executeProcesses(undefined, callbacks.errorProcess);
    };
    const projectId = (0, appStateSelectProjectId_1.default)(store.getState());
    if (databaseCore && databaseCore.delete) {
        databaseCore.delete({
            path: pathToDelete,
            shouldUpdateDbCache: !!shouldUpdateDbCache,
            projectId,
            listener,
            setRenderDbCache: (update) => {
                store.dispatch({
                    type: AppStateConstants_1.AppStateConstants.FIREBASE_REALTIME_DATABASE_UPDATE_CACHE,
                    payload: update,
                });
            },
            isDevelopment,
        });
    }
};
exports.default = deleteDataDBBuilder;
